import { useState } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button, cn } from '@proerp/ui';
import { Page, PageHeader } from '@/components/AppShell';
import { useCurrentUser, usePermissions } from '@/lib/useCurrentUser';
import { DashboardCustomizeDialog } from './DashboardCustomizeDialog';
import { visibleWidgets } from './widgets/layout';

const EMPTY_LAYOUT = { order: [], hidden: [] };

/**
 * Start-Dashboard (ADR 0062): rendert die Widgets aus der Registry, gefiltert nach
 * den Berechtigungen des Nutzers und angeordnet nach seinem gespeicherten Layout
 * (Baukasten). Finanz-Widgets erscheinen nur mit `dashboard.viewfinancials`. Der
 * Server erzwingt jede Datenquelle unabhängig vom Layout.
 */
export function DashboardPage() {
  const { can } = usePermissions();
  const { data } = useCurrentUser();
  const [customizing, setCustomizing] = useState(false);
  const layout = data?.data.dashboardLayout ?? EMPTY_LAYOUT;
  const visible = visibleWidgets(layout, can);

  return (
    <Page>
      <PageHeader
        title="Dashboard"
        subtitle="Kennzahlen und offene Aufgaben aus allen Modulen."
        actions={
          <Button variant="ghost" onClick={() => setCustomizing(true)}>
            <SlidersHorizontal className="size-4" strokeWidth={1.5} aria-hidden />
            Anpassen
          </Button>
        }
      />

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        {visible.map(({ id, size, Component }) => (
          <div key={id} className={cn(size === 'full' && 'lg:col-span-2')}>
            <Component />
          </div>
        ))}
      </div>

      <DashboardCustomizeDialog open={customizing} onOpenChange={setCustomizing} />
    </Page>
  );
}
